module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/full-crud-example/example-formly/example-formly.component.scss
// module id = ./src/app/components/examples/full-crud-example/example-formly/example-formly.component.scss
// module chunks = main